import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { OrganizationsService } from 'src/app/shared/services/organizations.service';
import { updateOrganization } from 'src/app/shared/models/organizations';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';

@Component({
  selector: 'app-edit-organization',
  templateUrl: './edit-organization.component.html',
  styleUrls: ['./edit-organization.component.scss']
})

export class EditOrganizationComponent implements OnInit {
  isSuperAdmin = false;
  dropdownOptions: string[] = ['GROK', 'SCHOOL', 'COLLEGE', 'INDUSTRY'];
  editOrgForm = new FormGroup({
    orgType: new FormControl('', [Validators.required]),
    orgName: new FormControl('', [Validators.required]),
    isDataCaptureEnabled: new FormControl(false),
    isDataVisualizationEnabled: new FormControl(false)
  })
  outline: boolean = false;
  outlineOrgType = false;
  formData: any;
  initialFormData: any;
  outlineOrgName = false;
  isLoading: boolean = false;
  orgList: any;
  organizationId: any;
  currentUser: any;
  isDataCaptureEnabled: boolean = false;
  isDataVisualizationEnabled: boolean = false;
  constructor(
    private router: Router,
    private toasterService: ToastrService,
    private organizationService: OrganizationsService,
    private activateRoute: ActivatedRoute,
    private sessionStorageService: SessionStorageService,
  ) {
    this.isSuperAdmin = window.location.href.includes('/admin/');
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.activateRoute.params.subscribe((params: any) => {
      console.log(params.orgId);
      this.organizationId = params.orgId;
      if (this.organizationId) {
        console.log(this.organizationId);
        this.getOrgdata(this.organizationId);
      }
      this.initialFormData = this.editOrgForm.value;
    });
    this.currentUser = this.sessionStorageService.getUsername();
  }

  onFocus(field: string) {
    if (field === 'orgType') {
      this.outlineOrgType = false;
    } else if (field === 'orgName') {
      this.outlineOrgName = false;
    }
  }

  getOrgdata(organizationId: any) {
    this.organizationService.get(organizationId).subscribe((orgData: any) => {
      console.log(orgData)
      this.formData = orgData;
      if (this.formData) {
        const orgType = this.formData.organization.organizationType || '';
        this.editOrgForm.patchValue({
          orgType: orgType,
          orgName: this.formData.organization.organizationName,
          isDataCaptureEnabled: this.formData.organization.isDataCaptureEnabled,
          isDataVisualizationEnabled: this.formData.organization.isDataVisualizationEnabled
        })
        this.isLoading = false;
        this.initialFormData = this.editOrgForm.value;
      }
    });
  }

  async onSubmit() {
    this.outlineOrgType = this.editOrgForm.get('orgType').invalid;
    this.outlineOrgName = this.editOrgForm.get('orgName').invalid;
    const controls = this.editOrgForm.controls;
    if (this.editOrgForm.valid) {
      try {
        const payload: updateOrganization = {
          organizationId: this.organizationId,
          userName: this.currentUser,
          isDataCaptureEnabled: controls['isDataCaptureEnabled'].value,
          isDataVisualizationEnabled: controls['isDataVisualizationEnabled'].value,
        };

        if (controls['orgName'].value.trim() !== this.initialFormData.orgName) {
          payload.organizationName = controls['orgName'].value.trim();
        }

        if (controls['orgType'].value !== this.initialFormData.orgType) {
          payload.organizationType = controls['orgType'].value;
        }
        if (payload.organizationName || payload.organizationType || controls['isDataCaptureEnabled'].value !== this.initialFormData.isDataCaptureEnabled || controls['isDataVisualizationEnabled'].value !== this.initialFormData.isDataVisualizationEnabled) {
          this.isLoading = true;
          const result: any = await this.organizationService.update(payload).toPromise();
          if (result) {
            this.toasterService.success("Organization updated successfully");
            this.onCancel();
            this.isLoading = false;
          }
        } else {
          this.toasterService.info("No changes detected. Press Cancel to Exit");
        }
      } catch (err: any) {
        this.isLoading = false;
        console.log(err, "error");
        if (err.status == 403) {
          console.log(err);
        } else {
          this.toasterService.error(`${err.error.message}`);
        }
      }
    }
  }



  onCancel() {
    if (this.isSuperAdmin) {
      this.router.navigateByUrl('/admin/organizations');
    } else {
      this.router.navigateByUrl('/ide/labs');
    }
  }
}